/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_ClosedInputs */

const en_contact_closed = /** @type {(inputs: Contact_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

const pl_contact_closed = /** @type {(inputs: Contact_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknięte`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Contact_ClosedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_closed = /** @type {((inputs?: Contact_ClosedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_ClosedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_closed(inputs)
	return en_contact_closed(inputs)
});